import {
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_PRACTIONERS_REQUEST,
  GET_PRACTIONERS_SUCCESS,
  USERS_DETAILS_REQUEST,
  USERS_DETAILS_SUCCESS,
  PRACTIONERS_DETAILS_REQUEST,
  PRACTIONERS_DETAILS_SUCCESS,
  GET_ALL_USERS_REQUEST,
  GET_ALL_USERS_SUCCESS,
  GET_INVITED_USERS_REQUEST,
  GET_INVITED_USERS_SUCCESS,
  GET_MY_PATIENT_DETAILS_REQUEST,
  GET_MY_PATIENT_DETAILS_SUCCESS,
  USERS_REMOVE_REQUEST,
  USERS_REMOVE_FAILED,
  USERS_REMOVE_SUCCESS,
  USER_STATUS_UPDATE_REQUEST,
  USER_STATUS_UPDATE_FAILED,
  USER_STATUS_UPDATE_SUCCESS,
  GET_USERS_EMAIL_SUCCESS,
  GET_USERS_EMAIL_REQUEST,
  GET_USERS_EMAIL_FAILED,
  GET_USER_PROGRAM_GRAPH_REQUEST,
  GET_USER_PROGRAM_GRAPH_FAILED,
  GET_USER_PROGRAM_GRAPH_SUCCESS,
  GET_USER_WATCH_GRAPH_REQUEST,
  GET_USER_WATCH_GRAPH_SUCCESS,
  GET_USER_WATCH_GRAPH_FAILED,
  PATIENT_REMOVE_REQUEST,
  PATIENT_REMOVE_FAILED,
  PATIENT_REMOVE_SUCCESS,
  GET_PRACTITIONERS_EMAIL_REQUEST,
  GET_PRACTITIONERS_EMAIL_SUCCESS,
  GET_PRACTITIONERS_EMAIL_FAILED,
  MAINTENANCE_MODE_SUCCESS,
  MAINTENANCE_MODE_FAILED,
  MAINTENANCE_MODE_REQUEST,
  GET_MAINTENANCE_MODE_REQUEST,
  GET_MAINTENANCE_MODE_SUCCESS,
  GET_MAINTENANCE_MODE_FAILED,
} from "../Actions/userAction";

const UsersInitialState = {
  loading: false,
  updateLoading: false,
  success: false,
  errors: {},
  usersPerPage: 10,
  currentPage: 1,
  totalCount: 0,
  userList: [],
  practionerList: [],
  doctorList: [],
  invitedList: [],
  userDetails: [],
  allUserList: [],
  practionerDetails: [],
  inviteDetails: [],
  myPatientDetails: {},
  emailsList: [],
  maintenanceStatus: {},
  userGraphDeatils: [
    { program_completion: [], icecap: [], factG: [], myCaw: [] },
  ],
  userWatchGraphDeatils: [{ steps: [], sleep: [], heart: [] }],
};

export const UserReducer = (state = UsersInitialState, action) => {
  switch (action.type) {
    case GET_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        userList: action?.payload,
        totalCount: action?.payload?.total,
      };
    case GET_ALL_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        allUserList: action?.payload?.patients_obj,
        totalCount: action?.payload?.count,
      };
    case GET_PRACTIONERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PRACTIONERS_SUCCESS:
      return {
        ...state,
        loading: false,
        practionerList: action?.payload?.doctors_obj,
        totalCount: action?.payload?.count,
      };

    case GET_PRACTITIONERS_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PRACTITIONERS_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        doctorList: action?.payload?.decryptData,
      };
    case GET_PRACTITIONERS_EMAIL_FAILED:
      return {
        ...state,
        loading: false,
      };

   
    case GET_INVITED_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_INVITED_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        invitedUserList: action?.payload,
        totalCount: action?.payload?.total,
      };
    case GET_MY_PATIENT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MY_PATIENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        myPatientDetails: action?.payload,
        totalCount: action?.payload?.total,
      };
    case PRACTIONERS_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PRACTIONERS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        practionerDetails: action?.payload,
        totalCount: action?.payload?.total,
      };
    case USERS_REMOVE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case USERS_REMOVE_SUCCESS:
      return {
        ...state,
        allUserList:
          action?.payload?.user_type === "CLIENTS"
            ? state?.allUserList?.filter(
                (item) => item?.id !== action?.payload?.Id
              )
            : "",
        practionerList:
          action?.payload?.user_type === "PRACTIONERS"
            ? state?.practionerList?.filter(
                (item) => item?.id !== action?.payload?.Id
              )
            : "",
        loading: false,
      };

    case USERS_REMOVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case PATIENT_REMOVE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case PATIENT_REMOVE_SUCCESS:
      let TPatients;
      let user_type = action?.payload?.user_type;
      user_type === "INVITED"
        ? (TPatients = state?.invitedUserList?.patients?.filter(
            (item) => item?.id !== action?.payload?.Id
          ))
        : (TPatients = state?.userList?.patients?.filter(
            (item) => item?.id !== action?.payload?.Id
          ));
      if (user_type === "INVITED") {
        return {
          ...state,
          invitedUserList: {
            ...state.invitedUserList,
            patients: TPatients,
          },
          loading: false,
          success: true,
        };
      } else {
        return {
          ...state,
          userList: {
            ...state.userList,
            patients: TPatients,
          },
          loading: false,
          success: true,
        };
      }
    case PATIENT_REMOVE_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case USER_STATUS_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        allUserList:
          action?.payload?.user_type === "CLIENTS"
            ? state?.allUserList?.map((item) =>
                item?.id === action?.payload?.data?.id
                  ? action?.payload?.data
                  : item
              )
            : "",
        practionerList:
          action?.payload?.user_type === "PRACTIONERS"
            ? state?.practionerList?.map((item) =>
                item?.id === action?.payload?.data?.id
                  ? action?.payload?.data
                  : item
              )
            : "",
        loading: false,
      };
    case USER_STATUS_UPDATE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case GET_USERS_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case GET_USERS_EMAIL_SUCCESS:
      return {
        ...state,
        emailsList: action?.payload?.data,
        loading: false,
        success: action?.payload?.success,
      };
    case GET_USERS_EMAIL_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case GET_MAINTENANCE_MODE_REQUEST:
      return {
        ...state,
         loading: true,
         success: false,
      };
   case GET_MAINTENANCE_MODE_SUCCESS:    
     return {
      ...state,
      loading: false,
      maintenanceStatus: action.payload,
      success: true,
    };
   case GET_MAINTENANCE_MODE_FAILED:
     return {
      ...state,
        loading: false,
        success: false,
     };

   case MAINTENANCE_MODE_REQUEST:
     return {
      ...state,
         loading: true,
         success: false,
     };
   case MAINTENANCE_MODE_SUCCESS:
     return {
      ...state,
      loading: false,
      success: true,
    };
   case MAINTENANCE_MODE_FAILED:
     return {
      ...state,
        loading: false,
        success: false,
     };

    default:
      return state;
  }
};

export const UserDetailsReducer = (state = UsersInitialState, action) => {
  switch (action.type) {
    case USERS_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USERS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetails: action?.payload,
      };
    case GET_USER_PROGRAM_GRAPH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_PROGRAM_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        userGraphDeatils: {
          program_completion: action.payload.program_completion,
          icecap: action.payload.icecap,
          factG: action.payload.factG,
          myCaw: action.payload.myCaw,
        },
      };
    case GET_USER_PROGRAM_GRAPH_FAILED:
      return {
        ...state,
        loading: false,
      };
    case GET_USER_WATCH_GRAPH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_WATCH_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        userWatchGraphDeatils: {
          steps: action.payload.steps,
          sleep: action.payload.sleep,
          heart: action.payload.heart,
        },
      };
    case GET_USER_WATCH_GRAPH_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
